module.exports = __webpack_public_path__ + "static/media/La_huella.b8d6111a.png";